/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Page from 'components/Page';
import { urlBannersHome } from 'constants/urls';
import BreadCrumbBanners from 'containers/HomeMex/components/BreadCrumbBanners';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import { Card } from 'primereact/card';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const API = ApiKeyFetch.instance();

const header = (data) => (
  <div className="text-center">
    <img alt="Card" src={data.urlImg} style={{ width: '100%' }} loading="eager" />
  </div>
);

const BodyCotizador = ({ slides = [], cotizadores = [] }) => {
  const history = useHistory();
  const { addWarningToast } = useCustomToast();
  const usuario = useUsuario();
  const [banners, setBanners] = useState([]);

  const redirect = (item) => () => {
    if (item.activo && item.urlRedireccion) {
      history.push(item.urlRedireccion);
    } else {
      addWarningToast(item.msgSinAcceso);
    }
  };

  const getInfoBanners = async () => {
    const Data = {
      tipo: 'welcome-home',
    };
    const res = await API.post(urlBannersHome, Data);
    if (res?.transaccion && res?.data?.data) {
      setBanners(res?.data?.data);
    }
  };

  useEffect(() => {
    if (usuario.isAgente) {
      getInfoBanners();
    }
  }, []);

  return (
    <main className="cr-content">
      <Page>
        <BreadCrumbBanners banners={banners} />

        <h1 className="display-3 text-mex text-center ">Cotiza en línea</h1>

        <div className="row justify-content-center my-5">
          {cotizadores.map((e, index) => (
            <div className="col-11 col-sm-11 col-md-5 col-lg-4 my-3" key={index}>
              <Card
                style={{ backgroundColor: '#C7DBF4', padding: '0' }}
                className="ui-card-shadow align-items-center"
                header={header(e)}
                footer={
                  <React.Fragment>
                    <button
                      className="btn-mex text-center cpointer w-100 ml-auto d-block d-sm-none border-0 rounded-0 text-white py-3 text-uppercase font-weight-bold "
                      style={{ fontFamily: 'Futura-Medium', fontSize: '22px' }}
                      onClick={redirect(e)}
                      id={`ramo-${e.ramo}`}
                    >
                      {e.nombreBoton}
                    </button>

                    <button
                      className="btn-mex text-center cpointer w-75 ml-auto d-none d-sm-block border-0 rounded-0 text-white py-3 text-uppercase font-weight-bold "
                      style={{ fontFamily: 'Futura-Medium', fontSize: '22px' }}
                      onClick={redirect(e)}
                      id={`ramo-${e.ramo}-lg`}
                    >
                      {e.nombreBoton}
                    </button>
                  </React.Fragment>
                }
              >
                <div className="mx-3 mx-lg-5" style={{ height: '10.5rem', overflowY: 'auto' }}>
                  <h3 className="text-mex font-weight-bold" style={{ fontSize: '30px' }}>
                    {e.titulo}
                  </h3>
                  <p className="mt-4 font-source-sans-regular" style={{ fontSize: '20px' }}>
                    {e.descripcion}
                  </p>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </Page>
    </main>
  );
};

export default BodyCotizador;

/*

        <Carousel
          className="mx-md-5 text-center"
          activeIndex={index}
          //onSelect={handleSelect}
          controls={false}
          indicators={false}
          style={{ backgroundColor: '#F0F0F0' }}
        >
          {slides.map((slide, index) => (
            <Carousel.Item key={uniqueId()}>
              <div
                className="d-block d-md-none text-center w-100 "
                style={{
                  marginTop: '5rem',
                  marginBottom: '5rem',
                  backgroundColor: '#F0F0F0',
                }}
              >
                <h1 className="display-3 text-center text-mex text-futura-bold">
                  {slide.titulo}
                </h1>
                <p className="text-futura-medium" style={{ fontSize: '18px' }}>
                  {slide.descripcion}
                </p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

        <Carousel
          className="mx-md-5 text-center"
          activeIndex={index}
          onSelect={handleSelect}
          controls={slides.length > 1}
          indicators={false}
        >
          {slides.map((slide, index) => (
            <Carousel.Item
              key={uniqueId()}
              className="w-100 py-5"
              style={{
                backgroundImage: `url(${slide.urlImg})`,
                backgroundSize: 'auto',
                backgroundRepeat: 'no-repeat',
                //display: 'block',
                boxSizing: 'border-box',
                height: '45rem',
                backgroundPosition: 'center center',
                //backgroundAttachment: 'fixed',
              }}
            >
              <div
                className="d-none d-sm-none d-md-block text-left"
                style={{ marginLeft: '7rem', width: '35%' }}
              >
                <h1 className="font-weight-bold display-4 text-mex mt-5 text-futura-bold">
                  {slide.titulo}
                </h1>
                <p className="mt-5 text-futura-medium" style={{ fontSize: '18px' }}>
                  {slide.descripcion}
                </p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>


*/
